import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Sales from "./pages/Sales";
import Reports from "./pages/Reports";
import InventoryReports from "./pages/InventoryReports";
import Settings from "./pages/Settings";
import UserRegister from "./pages/UserRegister";
import UserManagement from "./pages/UserManagement";
import ProductManagement from "./pages/ProductManagement";
import CustomerManagement from "./pages/CustomerManagement";
import CategoryManagement from "./pages/CategoryManagement";
import Layout from "./components/Layout";

const AppRoutes: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Layout>
              <Outlet />
            </Layout>
          ) : (
            <Navigate to="/login" />
          )
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="product-management" element={<ProductManagement />} />
        <Route path="sales" element={<Sales />} />
        <Route path="reports" element={<Reports />} />
        <Route path="inventory-reports" element={<InventoryReports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="user-register" element={<UserRegister />} />
        <Route path="user-management" element={<UserManagement />} />
        <Route path="customer-management" element={<CustomerManagement />} />
        <Route path="category-management" element={<CategoryManagement />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
